// import React, { useEffect } from 'react'
// import Header from '../../components/partials/dashboard/HeaderStyle/header'
// import RightSidebar from '../../components/partials/dashboard/SidebarStyle/rightsidebar'
// import Sidebar from '../../components/partials/dashboard/SidebarStyle/sidebar'
// import SettingOffCanvas from '../../components/setting/SettingOffCanvas'
// import { Navigate, Outlet } from 'react-router-dom'
// import { useNavigate } from 'react-router-dom';
// import {getToken} from '../../utils/auth';
// import CookieConsent from '../../components/cookie/CookieConsent'

// const rtlLanguages = ["ar", "urdu"];

// const Default = () => {
// const navigate = useNavigate();
//       useEffect(() => {
//     if (!getToken()) {
//       navigate("/auth/sign-in")
//     }
//   }, [])
//   const currentLang = localStorage.getItem("i18nextLng");
//     const isRTL = rtlLanguages.includes(currentLang);
//     return (
//         <div dir={isRTL ? "rtl" : "ltr"}>
//                 <Sidebar />
//                 <Header />
//                 <div className="main-content">
//                     <Outlet/>
//                 </div>
//                 <CookieConsent/>
//                 <RightSidebar />
//         </div>
//     )
// }

// export default Default


import React, { useEffect } from 'react'
import Header from '../../components/partials/dashboard/HeaderStyle/header'
import RightSidebar from '../../components/partials/dashboard/SidebarStyle/rightsidebar'
import Sidebar from '../../components/partials/dashboard/SidebarStyle/sidebar'
import SettingOffCanvas from '../../components/setting/SettingOffCanvas'
import { Navigate, Outlet } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import {getToken} from '../../utils/auth';
import CookieConsent from '../../components/cookie/CookieConsent'

const rtlLanguages = ["ar", "urdu"];

const Default = () => {
const navigate = useNavigate();
      useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in")
    }
  }, [])
  const currentLang = localStorage.getItem("i18nextLng");
    const isRTL = rtlLanguages.includes(currentLang);
    return (
        <div >
                <Sidebar isRTL={isRTL}/>
                <Header isRTL={isRTL}/>
                <div className="main-content" dir={isRTL ? "rtl" : "ltr"}>
                    <Outlet/>
                </div>
                <CookieConsent isRTL={isRTL}/>
                <RightSidebar isRTL={isRTL} />
        </div>
    )
}

export default Default
